import React from "react";
import { RequiredAuth } from "../../../utils/auth/RequiredAuth";
import { DefaultLayout } from "../../../components/layout/defaultLayout/index";
import { MFLHome } from "../pages/home";
import { OrgUnits } from "../pages/orgUnits";
import { APIDocumentation } from "../pages/apiDocumentation";
import { MFLHistory } from "../pages/history";
import { FacilityDetails } from "../pages/details";

const routes = () => [
  {
    path: "/:module/mfl-home",
    layout: DefaultLayout,
    component: () => (
      <RequiredAuth allowedRoles={["monitoring_sircev"]}>
        <MFLHome />
      </RequiredAuth>
    ),
  },
  {
    path: "/:module/orgunits",
    layout: DefaultLayout,
    component: () => (
      <RequiredAuth allowedRoles={["monitoring_sircev"]}>
        <OrgUnits />
      </RequiredAuth>
    ),
  },
  {
    path: "/:module/api-documentation",
    layout: DefaultLayout,
    component: () => (
      <RequiredAuth allowedRoles={["monitoring_sircev"]}>
        <APIDocumentation />
      </RequiredAuth>
    ),
  },
  {
    path: "/:module/mfl-history",
    layout: DefaultLayout,
    component: () => (
      <RequiredAuth allowedRoles={["monitoring_sircev"]}>
        <MFLHistory />
      </RequiredAuth>
    ),
  },
  {
    path: "/:module/mfl-details/:id",
    layout: DefaultLayout,
    component: () => (
      <RequiredAuth allowedRoles={["monitoring_sircev"]}>
        <FacilityDetails />
      </RequiredAuth>
    ),
  },
];
export { routes };
